// ** Icons Import
import { Heart } from 'react-feather'

const Footer = () => {
  return <p></p>
}

export default Footer
